import { cn } from '@/lib/utils';

interface HighlightLegendProps {
  /** Whether marking is live right now. False on read-only surfaces — past
   * marks are shown, but there is nothing to select. */
  interactive?: boolean;
  className?: string;
}

/**
 * Says what the colors mean, in the learner's language — never "correct /
 * incorrect."
 *
 * One reading only: these are the learner's two choices while they mark up the
 * vignette. There is no second reading, because the authored key is never shown
 * to them; it stays on the server and informs Howie's coaching instead.
 */
export function HighlightLegend({ interactive = true, className }: HighlightLegendProps) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-x-5 gap-y-2 text-xs leading-5 text-how-text-on-paper/70',
        className
      )}
    >
      <span className="inline-flex items-center gap-2">
        <span aria-hidden="true" className="unit-legend-swatch" data-kind="admirable" />
        What the leader did well
      </span>
      <span className="inline-flex items-center gap-2">
        <span aria-hidden="true" className="unit-legend-swatch" data-kind="adequate" />
        What worked, but cost something
      </span>

      {interactive && (
        <span className="text-how-text-on-paper/50">
          Select any passage to mark it
        </span>
      )}
    </div>
  );
}

export default HighlightLegend;
